export default __webpack_public_path__ + "static/media/experience_sec4.844e14da.png";